import { Provider } from "react-redux";
import { useRouter } from "next/router";
import ShortsData from "../../../data/shorts.json";
import PageHead from "../../Head";
import Store from "@/redux/store";
import Context from "@/context/Context";
import MobileMenu from "@/components/Header/MobileMenu";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import Cart from "@/components/Header/Offcanvas/Cart";
import Banner from "@/components/Common/Banner";
// import BlogGrid from "@/components/Blogs/BlogGrid";
import ShortsEpisodes from "@/components/Shorts/ShortsEpisodes";
import BackToTop from "../../backToTop";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
// import BlogGridMinimal from "@/components/Blogs/BlogGridMinimal";
import Instagram from "@/components/Instagram/Instagram";
import GoogleAdLarge from "@/components/Ads/GoogleAdLarge";
import CPStaticContent from '../../../models/CPStaticContent.js'

const BlogGridLayout = (post) => {
  console.log(post)
  const router = useRouter();
  const seasonId = router.query.postId;

  // let seasonsList = JSON.parse(JSON.stringify(ShortsData.seasonList));
  // let seasonData = seasonsList.find((item) => item.id === seasonId);
  let seasonData = post.season
  const seasonTitle = "Season: " + (seasonData)?.season || "1";

  let shortEpisodes = JSON.parse(JSON.stringify(ShortsData.episodeList));
  let getAllEpisodes = post.episodes.sort((a, b) => a.episode - b.episode);
  // let getAllEpisodes = post.episodes

  return (
    <>
      <PageHead title="Learn Cloud Computing through Shorts" />
      <Provider store={Store}>
        <Context>
          <MobileMenu />
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <Cart />

          <Banner col="col-lg-12" text={seasonTitle} getBlog={getAllEpisodes} listType="Episodes" />
          <div className="rbt-blog-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              {/* <BlogGridMinimal start={0} end={3} isPagination={false} /> */}
              <ShortsEpisodes shortsSeason={seasonData} blogType="short" blogData={getAllEpisodes} isPagination={true} top={true} start={0} end={10} />
              <br /><br />
              <GoogleAdLarge />
            </div>
          </div>


          <Instagram />
          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default BlogGridLayout;

export async function getStaticProps(context) {
  let seasonsList = JSON.parse(JSON.stringify(ShortsData.seasonList));
  let seasonData = seasonsList.find((item) => item.id === "cloud-computing-basic-concepts");

  // const stContentSeason = new CPStaticContent("shorts-seasons")
  // await stContentSeason.fetchContent()
  // let season = await stContentSeason.getListProps(context.params.postId)
  // console.log(season)

  const stContent = new CPStaticContent("shorts")
  await stContent.fetchContent()
  let eps = await stContent.getListProps()
  return await { props: { season: seasonData, episodes: eps.props.list } }
}

export async function getStaticPaths(context) {
  const stContent = new CPStaticContent("shorts-seasons")
  await stContent.fetchContent()
  const paths = await stContent.getPaths()
  return { paths, fallback: false }
}
